import { useMutation } from '@tanstack/react-query'
import { getCurrentUserRoleInfo } from '#shared/lib/auth'
import sendOrderFeedback from '../api/send-order-feedback'
import SendOrderFeedbackPayload from '../model/send-order-feedback-payload'

export default function useOrderFeedBackMutation() {
  const roleInfo = getCurrentUserRoleInfo()
  const role = roleInfo.role

  return useMutation({
    mutationFn: (payload: SendOrderFeedbackPayload) => {
      if (role !== 'client' && role !== 'staff') return Promise.resolve()
      return sendOrderFeedback(payload, role)
    },
  })
}
